var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"eb0ab31bda3a1092cbfb8ae7cce8bccc7b7a27dd"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["tailplane-site@tailplane"]={id:"eb0ab31bda3a1092cbfb8ae7cce8bccc7b7a27dd"};
      